// ** React Imports
import { lazy } from 'react';

/**
 * Push notifications live under Marketing, beside popups and coupons —
 * the other two ways the shop reaches a customer who is not on the site.
 */
const PushNotificationRoutes = [
  {
    path: 'marketing/push/templates',
    component: lazy(() => import('views/push/templates')),
  },
  {
    path: 'marketing/push/campaigns',
    component: lazy(() => import('views/push/campaigns')),
  },
  {
    path: 'marketing/push/devices',
    component: lazy(() => import('views/push/devices')),
  },
];

export default PushNotificationRoutes;
